// extracted by mini-css-extract-plugin
export default {"ButtonPlaceholder":"HtUqmFU3","ButtonSkeleton":"zfs5sZGQ","IconPlaceholder":"eZ2CHaFQ","CharacterCount":"KTkd5pGf"};